import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/tebii.jpeg";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const Footer = (props) => {
  return (
    <footer className={"" + props.hclass}>
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={logo} alt="blog" style={{ maxWidth: "25%" }} />
                </div>
                <p>
                  We are Manufacturer And marketers of Pharamaceutical Products
                  and herble cosmetics Products in india
                </p>
                <div className="social-widget">
                  <ul>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="flaticon-facebook-app-symbol"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="flaticon-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="flaticon-linkedin"></i>
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="#">
                        <i className="flaticon-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Quick Links</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/home">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      About Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget s2">
                <div className="widget-title">
                  <h3>Useful Links</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/products">
                      Products We Offer
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contact us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget contact-widget">
                <div className="widget-title">
                  <h3>Contact Us</h3>
                </div>
                <ul>
                  <li>
                    <i className="flaticon-email"></i>
                    <span>info@tebiilifecare.com</span>
                  </li>
                  <li>
                    {" "}
                    <i className="flaticon-telephone"></i>
                    <span>
                      <strong>(+91)</strong> 83 292 35 018
                    </span>
                  </li>
                  <li>
                    <i className="flaticon-location-1"></i>
                    <span>
                      Flat no 603, <br />
                      vrundavan terrace gardan, saneguruji vasahat
                      <br />
                      Kolhapur, Maharashtra 416011
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row g-0">
            <div className="col col-lg-6 col-12">
              <p className="copyright">
                {" "}
                Copyright &copy; 2025 Tebii lifecare by{" "}
                <Link onClick={ClickHandler} to="/">
                  Tebii lifecare
                </Link>
                . All Rights Reserved.
              </p>
            </div>
            <div className="col col-lg-6 col-12">
              <ul>
                <li>
                  <Link onClick={ClickHandler} to="/about">
                    About us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
